import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <div
      className="bgImage !h-[294px] mb-[60px]"
      style={{ backgroundImage: `url(/images/home-hero.webp)` }}
    >
      <div className="w-full h-full bg-black/50">
        <div className="w-full h-full justify-center items-center hidden lg:flex">
          <div className="w-full max-w-8xl margins flex items-center">
            <div className="max-w-[700px] text-[32px] font-semibold text-white leading-[54px] mr-[175px]">
              Explore your journey with Maraliner Now! Get 25% Exclusive
              discount.
            </div>
            <Link className="min-w-[178px] h-[48px] px-6 flex items-center justify-center bg-black text-base text-white font-semibold rounded-[10px]">
              Explore Now
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
